import React, { useCallback, useEffect } from 'react'
import { CheckboxWmo, Modal } from '@usap/uicomponents'
import { StaticData } from '@usap/widgets'
import {
  StyledCheckboxLabel,
  StyledContainer,
  StyledLearnMoreButton,
  StyledPrice,
  StyledLearnMoreModalSubtitle,
  StyledWarrantyInfo,
} from './WarrantyWmo.css'
import Accordion from '../../../../../Accordion/Accordion'
import { GTM } from '../../../../../../helpers';

// Capitalize first letter of each word
const formatWarrantyType = type => {
  if (!type) {
    return ''
  }
  const words = type.toLowerCase().split(' ')
  return words.map(word => word[0].toUpperCase() + word.substring(1)).join(' ')
}

const WarrantyWmo = ({
  showTooltip,
  warrantyData,
  sku,
  partName,
  warrantyText,
  shouldShowTooltip,
  type,
  quantity,
  formattedPrice,
  formattedTotalPrice,
  handleWarranty,
  handleShowTooltip,
  isChecked,
  dataTestId,
}) => {
  useEffect(() => {
    GTM.cppDisplayedOnCartPage(sku, partName)
  }, [])

  const onCheckboxClick = useCallback(() => {
    if (isChecked) {
      GTM.cppUncheckedOnCartPage(sku, partName, formattedTotalPrice)
    } else {
      GTM.cppCheckedOnCartPage(sku, partName, formattedTotalPrice)
    }
    handleWarranty({ target: { checked: !isChecked } })
  }, [handleWarranty, isChecked])

  const checkboxLabel = (
    <StyledCheckboxLabel>
      {`Add ${formatWarrantyType(type)} Protection Plan`}
      <StyledPrice>
        ${formattedTotalPrice}
        {quantity > 1 && ` ($${formattedPrice} each)`}
      </StyledPrice>
    </StyledCheckboxLabel>
  )

  return (
    <StyledContainer>
      <Modal
        open={showTooltip}
        onOpenChange={shouldShowTooltip}
        header={warrantyData?.heading}
        content={(
              warrantyData ? (
                <>
                  <StyledLearnMoreModalSubtitle>{warrantyData.subtitle}</StyledLearnMoreModalSubtitle>
                  <Accordion
                    items={warrantyData.items}
                  />
                </>
              ) : <StaticData records={warrantyText} />
        )}
      />
      <CheckboxWmo
        onChange={onCheckboxClick}
        data-testid={dataTestId?.protectionPlanCheckbox}
        label={checkboxLabel}
        checked={isChecked}
      />

      <StyledWarrantyInfo>
        Protect your purchase with a hassle-free protection plan.
        {' '}
        <StyledLearnMoreButton onClick={handleShowTooltip} data-testid={dataTestId?.whatsThis}>
          Learn More
        </StyledLearnMoreButton>
      </StyledWarrantyInfo>
    </StyledContainer>
  )
}

export default WarrantyWmo
